import * as React from "react";
import { DeviceChangeDispatcherMock, BaseBlock, broadcastBlockLoad } from "../../dependencies";
import { connectionFactory } from "../../connections";
import { CardConfigs, FilterManager } from "../../helpers";
import { Parser } from "../../Parser";
import { Retriever } from "../../Retriever";
import { Piper } from "../../piper";
import { cmsConfig } from "./config";
import { dict } from "./dict";
import { EventListPresenter } from "./ui";
import { EventListPresenterState } from "./state";
let _localMocks;
let EventListOptionsMock, deviceChangeDispatcherMock, connectionFactoryMock;
if (process.env.NODE_ENV === "development") {
    _localMocks = require("../../mocks/");
    EventListOptionsMock = _localMocks.EventListOptionsMock;
    connectionFactoryMock = _localMocks.connectionFactoryMock;
}
export class EventListPresenterRoot extends BaseBlock {
    constructor(domId, options) {
        super(domId, options);
        const meta = { requesterId: domId };
        let connectionFactoryGateway;
        if (process.env.NODE_ENV === "development") {
            this.options = Object.assign(Object.assign({}, EventListOptionsMock), options);
            deviceChangeDispatcherMock = DeviceChangeDispatcherMock.getInstance();
            connectionFactoryGateway = connectionFactoryMock(meta);
            this.options.navHandler.Navigation = {
                adjustSportsPath: (url) => `en/sports/${url}`,
                getLiveEventLink: (id) => `en/live-betting/#${id}`,
                getLiveBettingLink: () => "en/live-betting"
            };
            this.options.navHandler.OpenLeague = () => { };
            // connectionFactoryGateway = connectionFactory(meta) //This line should be uncommented to be run with real API
            window["EventListPresenterDATA"] = this.dataProvider;
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            this.options = options;
            connectionFactoryGateway = connectionFactory(meta);
        }
        this.options.dict = Object.assign(Object.assign({}, dict), (this.options.dict || {}));
        this.options.cms = Object.assign(Object.assign({}, cmsConfig), (this.options.cms || {}));
        let cardConfig = new CardConfigs();
        let filterManager = new FilterManager();
        cardConfig.setConfig(this.options.dataProvider.cardConfiguration, this.options.dataProvider.cardConfigurationEventView);
        this.dataProvider = new EventListPresenterState(new Parser(new Retriever(this.options.dataProvider, this.options.cms, cardConfig, filterManager, connectionFactoryGateway, deviceChangeDispatcherMock), new Piper(this.options.dataProvider.pipeline), {
            requestParams: this.getAvailableRequestParams(),
            navFunctions: {
                adjustSportsPath: this.options.navHandler.Navigation.adjustSportsPath,
                adjustLivePath: this.options.navHandler.Navigation.getLiveEventLink
            },
            specialLeagues: this.options.dataProvider.specialLeagues,
            parserCmsConfig: {
                topicPrefix: this.options.cms.BlockId,
                clientId: this.options.cms.BetRadarStatisticClientId,
                hasSettlementDate: this.options.cms.hasSettlementDate,
                sortIPTopLeaguesFirst: this.options.cms.SortIPTopLeaguesFirst,
                showStatisticsIcon: this.options.cms.ShowStatisticsIcon,
                isMBNEnabled: this.options.cms.IsMBNEnabled,
                shouldSortEventsByTime: this.options.cms.ShouldSortEventsByTime,
                outrightSortOptions: {
                    nameSortSportIds: this.options.cms.NameSortSportIds,
                    locale: this.options.cms.Locale
                },
                isMarketsDropdownFilterEnabled: this.options.cms.EnableMarketsDropdownFilter,
                isLiveSchedule: this.options.cms.IsLiveSchedule,
                hourFormat: this.options.cms.HourFormat,
                trackingId: this.options.cms.TrackingId
            },
            localizationLib: this.options.localizationLib,
            dict: this.options.dict
        }), this.options);
    }
    activate() {
        return super.activate(React.createElement(EventListPresenter, { dataProvider: this.dataProvider, dict: this.options.dict, cms: this.options.cms }));
    }
    beforeActivate() {
        this.dataProvider.activate();
        return this;
    }
    beforeDeactivate() {
        this.dataProvider.deactivate();
        return this;
    }
    setParams(sportId) {
        this.dataProvider.provider.setParams([sportId]);
    }
    getAvailableRequestParams() {
        let sportIds = [], dateRange;
        if (this.options.dataProvider.eventsRequest) {
            sportIds = this.options.dataProvider.eventsRequest.request.ids;
            dateRange = this.options.dataProvider.eventsRequest.request.dateRange;
        }
        else if (this.options.dataProvider.eventsRequestOutrights) {
            sportIds = this.options.dataProvider.eventsRequestOutrights.request.ids;
            dateRange = this.options.dataProvider.eventsRequestOutrights.request.dateRange;
        }
        return {
            sportIds,
            allSportIds: this.options.dataProvider.allSportIds,
            dateRange
        };
    }
}
window["EventListPresenter"] = EventListPresenterRoot;
broadcastBlockLoad("EventListPresenter");
//# sourceMappingURL=index.js.map